import React, { Component } from "react";
import { fetchHtmlReportingConfig, fetchHtmlReportData } from "../../util/htmlReporting/htmlReporting";
import { LinearProgress } from "@material-ui/core";

class HtmlReport extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    const asyncFunc = async () => {
      // HTML reporting
      let reportName = window.location.href.split('/')
      reportName = reportName[reportName.length - 1]
      this.setState(e => { return { ...e, isHtmlReport: true, isLoadingHtmlReport: true } })
      let s3Url = await fetchHtmlReportData(reportName)
      this.setState({
        s3Url: s3Url,
        isLoadingHtmlReport: false,
      })
    }
    asyncFunc()
  }
  render() {
    return (
      <React.Fragment>
        {!this.state.isLoadingHtmlReport ? (
          <iframe src={this.state.s3Url} className="powerBiCustom" />
        ) : (
          <div className="powerBiCustom" style={{ backgroundColor: '#eeeeee' }}>
            <h1 style={{ textAlign: 'center' }}>Loading report. Please Wait!</h1>
            <LinearProgress color="primary" style={{ width: '100%' }} />
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default HtmlReport;



// WEBPACK FOOTER //
// ./src/views/HtmlReporting/htmlReport.jsx